var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-dialog',{ref:"dialog",attrs:{"title":_vm.originalData ? 'Update' : 'Create',"inputs-map":_vm.formData,"input-value-change":_vm.valueChange,"save-cb":_vm.saveData,"reset-inputs":_vm.resetData}})
}
var staticRenderFns = []

export { render, staticRenderFns }